(ns vit-configurator.views.size
  (:require [clojure.string :as str]
            [re-frame.core :as re-frame]
            [vit-configurator.events :as events]
            [vit-configurator.subs :as subs]
            [vit-configurator.views.select-view :as sel-v]))

(defn size-select-card
  "Like select-view/select-card, but with a second 'type' dropdown menu,
   which updates a different subscription and can disable the 'size' dropdown"
  [{:keys [card-id select-id title-text description-text
           subscription event-kw type-event-kw
           options type-options select-label type-label]}
   current-type]
  (let [current-val @(re-frame/subscribe [subscription])]
    [:fieldset {:id card-id}
     [:label.pr-4 type-label]
     [:div
      [:select.mb-2.mw-100
       (merge
        (when current-type
          {:value current-type})
        {:id (str select-id "-type")
         :on-change (fn [selection]
                      (println selection)
                      (let [new-val (-> selection
                                        (.. -target -value)
                                        keyword)]
                        (re-frame/dispatch [type-event-kw new-val])))})
       (map sel-v/option type-options)]]
     (when-not (= current-type :search)
       [:label.pr-4 select-label])
     (when-not (= current-type :search)
       [:div.mb-2
        [:select.mw-100
         (merge
          (when current-val
            {:value current-val})
          {:id select-id
           :on-change (fn [selection]
                        (let [new-val (-> selection
                                          (.. -target -value)
                                          keyword)]
                          (re-frame/dispatch
                           [event-kw new-val])))})
         (map sel-v/option options)]])
     (when-not (str/blank? description-text)
       [:p.mb-0.small {:dangerouslySetInnerHTML {:__html description-text}}])]))


(defn customizer
  [current-type]
  (let [options {:description-text "<a target=\"_blank\" href=\"https://www.votinginfoproject.org/tools/widgets#customize-size\">Learn more about widget types and sizes</a>"
                 :subscription ::subs/size
                 :event-kw ::events/set-size
                 :options [[:container-responsive "Responsive to container size"]
                           [:full "Flexible 100% of containing column"]
                           [:responsive "Flexible between 360px to 640px wide"]
                           [:large-responsive "Flexible between 360px to 960px wide"]
                           [:small "Fixed 360px wide"]
                           [:regular "Fixed 640px wide"]]
                 :type-event-kw ::events/set-search-box-type
                 :type-options [[:dialog "Dialog box"]
                                [:search "Search box"]]
                 :card-id "size"
                 :select-id "size-select"
                 :select-label "Select a Size"
                 :type-label "Select Type"}]
   (size-select-card options current-type)))
